"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedFactory = void 0;
var tslib_1 = require("tslib");
var Factory_1 = require("./Factory");
var intersection_1 = require("../intersection");
var ManagedFactory = /** @class */ (function (_super) {
    tslib_1.__extends(ManagedFactory, _super);
    function ManagedFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Methods that are added to object instances
         * This property is an alias for this factory type prototype
         * @name methods
         */
        _this.methods = null;
        /**
         * The managed type of this factory
         */
        _this.managedType = null;
        /**
         * The owning EntityManager where this factory belongs to
         */
        _this.db = null;
        return _this;
    }
    /**
     * Creates a new ManagedFactory for the given type
     * @param managedType The metadata of type T
     * @param db The entity manager instance
     */
    ManagedFactory.create = function (managedType, db) {
        var factory = this.createFactory(managedType.typeConstructor);
        factory.methods = factory.prototype;
        factory.managedType = managedType;
        factory.db = db;
        return factory;
    };
    /**
     * Creates a new instance and sets the Managed Object to the given json
     * @param json
     * @return A new created instance of T
     */
    ManagedFactory.prototype.fromJSON = function (json) {
        var instance = this.newInstance();
        return this.managedType.fromJsonValue(intersection_1.Metadata.create(this.managedType, this.db), json, instance, {
            persisting: false,
        });
    };
    /**
     * Adds methods to instances of this factories type
     * @param methods The methods to add
     * @return
     */
    ManagedFactory.prototype.addMethods = function (methods) {
        Object.assign(this.methods, methods);
    };
    /**
     * Add a method to instances of this factories type
     * @param name The method name to add
     * @param fn The Method to add
     * @return
     */
    ManagedFactory.prototype.addMethod = function (name, fn) {
        this.methods[name] = fn;
    };
    return ManagedFactory;
}(Factory_1.Factory));
exports.ManagedFactory = ManagedFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFuYWdlZEZhY3RvcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNYW5hZ2VkRmFjdG9yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscUNBQW9DO0FBS3BDLGdEQUEyQztBQUUzQztJQUF1RCwwQ0FBVTtJQUFqRTtRQUFBLHFFQStEQztRQS9DQzs7OztXQUlHO1FBQ0ksYUFBTyxHQUFrQyxJQUFXLENBQUM7UUFFNUQ7O1dBRUc7UUFDSSxpQkFBVyxHQUFtQixJQUFXLENBQUM7UUFFakQ7O1dBRUc7UUFDSSxRQUFFLEdBQWtCLElBQVcsQ0FBQzs7SUFnQ3pDLENBQUM7SUE5REM7Ozs7T0FJRztJQUNXLHFCQUFNLEdBQXBCLFVBQXdDLFdBQTJCLEVBQUUsRUFBaUI7UUFDcEYsSUFBTSxPQUFPLEdBQXNCLElBQUksQ0FBQyxhQUFhLENBQXVCLFdBQVcsQ0FBQyxlQUFlLENBQUMsQ0FBQztRQUV6RyxPQUFPLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUM7UUFDcEMsT0FBTyxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7UUFDbEMsT0FBTyxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7UUFFaEIsT0FBTyxPQUFPLENBQUM7SUFDakIsQ0FBQztJQW1CRDs7OztPQUlHO0lBQ0gsaUNBQVEsR0FBUixVQUFTLElBQVU7UUFDakIsSUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDO1FBQ3BDLE9BQU8sSUFBSSxDQUFDLFdBQVcsQ0FBQyxhQUFhLENBQUMsdUJBQVEsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRTtZQUNoRyxVQUFVLEVBQUUsS0FBSztTQUNsQixDQUFFLENBQUM7SUFDTixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNILG1DQUFVLEdBQVYsVUFBVyxPQUFxQztRQUM5QyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0gsa0NBQVMsR0FBVCxVQUFVLElBQVksRUFBRSxFQUFZO1FBQ2xDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDO0lBQzFCLENBQUM7SUFDSCxxQkFBQztBQUFELENBQUMsQUEvREQsQ0FBdUQsaUJBQU8sR0ErRDdEO0FBL0RZLHdDQUFjIn0=